export default __webpack_public_path__ + "static/media/mastenkraan.b5aad1f4.svg";